/**
 * DBCD — Convergência e Divergência de BIAS.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLMomentum.cs, classe
 * FML.DBCD). Painel próprio, 2 linhas:
 *
 *   BIAS = (C − MA(C,N)) / MA(C,N)
 *   DIF  = BIAS − REF(BIAS, M)
 *   DBCD = SMA(DIF, T, 1)          (SMA-chinesa)
 *   MM   = MA(DBCD, 5)             (janela 5 fixa no engine)
 *
 * Valores são razões pequenas (ordem 1e-5 em intraday). Paridade provada em
 * __tests__/dbcd.silverlight.test.js.
 */
import { ma, sub, div, ref, sma } from "./silverlightDsl";
import { DBCD as defaultOptions } from "./defaultOptionsForComputation";

const MM_WINDOW = 5; // fixo no engine (MA(DBCD,5))

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period, m, t } = options;
    const close = data.map((d) =>
      Number.isFinite(d.close) ? d.close : Number.NaN,
    );

    const maClose = ma(close, period);
    const bias = div(sub(close, maClose), maClose);
    const dif = sub(bias, ref(bias, m));
    const dbcd = sma(dif, t, 1);
    const mm = ma(dbcd, MM_WINDOW);

    return dbcd.map((v, i) => {
      const dbcdOut = Number.isFinite(v) ? v : undefined;
      const mmOut = Number.isFinite(mm[i]) ? mm[i] : undefined;
      if (dbcdOut === undefined && mmOut === undefined) return undefined;
      return { dbcd: dbcdOut, mm: mmOut };
    });
  }

  calculator.undefinedLength = function () {
    const { t } = options;
    // A SMA-chinesa reinicia após os NaN do BIAS/DIF: o warm-up efetivo
    // observado no engine é T (confirmado pelo oráculo).
    return Math.max(0, t + MM_WINDOW - 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
